module.exports = __webpack_public_path__ + "5240f49f71ea31e51cfb65f18a88714d.ttf";